import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { Drawer, Form } from 'antd';
import { useAuthContext } from '../../../../contexts/AuthContext';
import { useErrorMessage } from '../../../../utils/errorMessage';
import { useFields } from './fields';
import { useGenerateFormItem } from '../../../../utils/generateFormItem';
import { DrawerFormContent } from '../../utils/DrawerFormContent';
import { onFinishForm } from '../utils/onFinishForm';

export const CreateUpdateDrawer = ({
  visible,
  setVisible,
  setRefreshData,
  refreshData,
  generalConditions,
  purpose,
  generalConditionToEdit
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const { dispatchAPI } = useAuthContext();
  const { message } = useErrorMessage();
  const generateFormItem = useGenerateFormItem();
  const { fields } = useFields({
    generalConditions,
    purpose,
    generalConditionToEdit
  });

  const onClose = () => {
    form.resetFields();
    setVisible(false);
  };

  useEffect(() => {
    if (purpose === 'edit') {
      form.setFieldsValue({
        ...generalConditionToEdit,
        application_date: dayjs(generalConditionToEdit.application_date),
        end_date: dayjs(generalConditionToEdit.end_date)
      });
    }
  }, [purpose]);

  return (
    <Drawer
      destroyOnClose
      title={t(`general-conditions.form.title.drawer.${purpose}`)}
      width="70vw"
      onClose={onClose}
      visible={visible}
      getContainer={false}
    >
      <DrawerFormContent
        form={form}
        onFinish={(values) =>
          onFinishForm({
            values,
            purpose,
            generalConditions,
            dispatchAPI,
            generalConditionToEdit,
            setVisible,
            setRefreshData,
            refreshData,
            message
          })
        }
        fields={fields}
        generateFormItem={generateFormItem}
        resourceKey="general-conditions"
        onClose={onClose}
      />
    </Drawer>
  );
};

CreateUpdateDrawer.propTypes = {
  visible: PropTypes.bool,
  setVisible: PropTypes.func,
  setRefreshData: PropTypes.func,
  refreshData: PropTypes.bool,
  supervisionPrice: PropTypes.shape({}).isRequired,
  purpose: PropTypes.string.isRequired,
  generalConditionToEdit: PropTypes.shape({
    application_date: PropTypes.string,
    end_date: PropTypes.string,
    _id: PropTypes.string
  }),
  generalConditions: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

CreateUpdateDrawer.defaultProps = {
  visible: false,
  setVisible: null,
  setRefreshData: null,
  refreshData: false,
  generalConditionToEdit: null
};
